<header class="header-sticky">
  <app-top-bar></app-top-bar>
  <div class="container">
    <form [formGroup]="formSearch" autocomplete="off" (submit)="search()">
        <div class="d-flex justify-content-center align-items-center mt-3">
            <div class="">
                <div [mdcElevation]="1" class="box-search mw-100 my-2">
                    <div class="d-flex align-items-center">
                        <div>
                            <!-- <button type="submit" mat-icon-button>
                                <mat-icon>search</mat-icon>
                            </button> -->
                        </div>
                        <div class="flex-grow-1">
                            <!-- <input type="search" #txtBusqueda formControlName="busqueda" class="txt-search d-block m-0 p-0 w-100" placeholder="Buscar Productos"> -->
                        </div>
                        <div *ngIf="globals.configuracion.front.typeabbrev == '01'">
                            <!-- <button type="button" mat-icon-button [matMenuTriggerFor]="menuOrdenar">
                                <mat-icon>filter_list</mat-icon>
                            </b
                            tton> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="">
                <!-- <button type="button" mat-button color="primary" class="bg-white text-primary text-decoration-underline" *ngIf="globals.configuracion.front.typeabbrev == '02'" [matMenuTriggerFor]="menuOrdenar">
                    <span *ngIf="globals.configuracion.front.listado.tag == '' && globals.configuracion.front.listado.ordenar_new == 'reciente'">Recientes</span>
                    <span *ngIf="globals.configuracion.front.listado.tag == '' && globals.configuracion.front.listado.ordenar_new == 'relevancia_producto' && globals.configuracion.front.listado.ordenar_modo == 'desc'">Más Vendidos</span>
                    <span *ngIf="globals.configuracion.front.listado.tag == '' && globals.configuracion.front.listado.ordenar_new == 'nombre_producto' && globals.configuracion.front.listado.ordenar_modo == 'asc'">Ordenar por nombre</span>
                    <span *ngIf="globals.configuracion.front.listado.tag == '' && globals.configuracion.front.listado.ordenar_new == 'precio_producto' && globals.configuracion.front.listado.ordenar_modo == 'desc'">Mayor precio</span>
                    <span *ngIf="globals.configuracion.front.listado.tag == '' && globals.configuracion.front.listado.ordenar_new == 'precio_producto' && globals.configuracion.front.listado.ordenar_modo == 'asc'">Menor precio</span>

                    <span *ngIf="globals.configuracion.front.listado.tag != ''">{{ globals.configuracion.front.listado.tag_descripcion }}</span>
                </button> -->
            </div>
        </div>
        <mat-menu #menuOrdenar="matMenu" class="menu-ordenar">
            <button mat-menu-item [class.activo]="globals.configuracion.front.listado.tag == '' && globals.configuracion.front.listado.ordenar_new == 'reciente'" (click)="ordenarListado( 'reciente','desc' )">
                <mat-icon>event</mat-icon>
                <span>Recientes</span>
            </button>
            <!--
            <button mat-menu-item [class.activo]="globals.configuracion.front.listado.ordenar_new == 'relevancia_producto' && globals.configuracion.front.listado.ordenar_modo == 'asc'" (click)="ordenarListado( 'relevancia_producto','asc' )">
                <mat-icon>grade</mat-icon>
                <span>Ordenar por relevancia <mat-icon>arrow_upward</mat-icon></span>
            </button>
            -->
            <button mat-menu-item [class.activo]="globals.configuracion.front.listado.tag == '' && globals.configuracion.front.listado.ordenar_new == 'relevancia_producto' && globals.configuracion.front.listado.ordenar_modo == 'desc'" (click)="ordenarListado( 'relevancia_producto','desc' )">
                <mat-icon>grade</mat-icon>
                <span>Más Vendidos <!--<mat-icon>arrow_downward</mat-icon>--></span>
            </button>
            <button mat-menu-item [class.activo]="globals.configuracion.front.listado.tag == '' && globals.configuracion.front.listado.ordenar_new == 'nombre_producto' && globals.configuracion.front.listado.ordenar_modo == 'asc'" (click)="ordenarListado( 'nombre_producto','asc' )">
                <mat-icon>sort_by_alpha</mat-icon>
                <span>Ordenar por nombre <!--<mat-icon>arrow_upward</mat-icon>--></span>
            </button>
            <!--
            <button mat-menu-item [class.activo]="globals.configuracion.front.listado.ordenar_new == 'nombre_producto' && globals.configuracion.front.listado.ordenar_modo == 'desc'" (click)="ordenarListado( 'nombre_producto','desc' )">
                <mat-icon>sort_by_alpha</mat-icon>
                <span>Ordenar por nombre <mat-icon>arrow_downward</mat-icon></span>
            </button>
            -->
            <button mat-menu-item [class.activo]="globals.configuracion.front.listado.tag == '' && globals.configuracion.front.listado.ordenar_new == 'precio_producto' && globals.configuracion.front.listado.ordenar_modo == 'desc'" (click)="ordenarListado( 'precio_producto','desc' )">
                <mat-icon>attach_money</mat-icon>
                <span>Mayor Precio <!--<mat-icon>arrow_downward</mat-icon>--></span>
            </button>
            <button mat-menu-item [class.activo]="globals.configuracion.front.listado.tag == '' && globals.configuracion.front.listado.ordenar_new == 'precio_producto' && globals.configuracion.front.listado.ordenar_modo == 'asc'" (click)="ordenarListado( 'precio_producto','asc' )">
                <mat-icon>attach_money</mat-icon>
                <span>Menor Precio <!--<mat-icon>arrow_upward</mat-icon>--></span>
            </button>

            <!--
            <button *ngIf="globals.configuracion.front.typeabbrev == '02'" mat-menu-item (click)="filtroModelos()">
                <mat-icon>filter_alt</mat-icon>
                <span>Modelos</span>
            </button>
            -->
            <button *ngIf="globals.configuracion.front.typeabbrev == '02'" mat-menu-item [class.activo]="globals.configuracion.front.listado.tag != ''" (click)="filtroTags()">
                <mat-icon>filter_alt</mat-icon>
                <span>Modelos y Categorías</span>
            </button>

            <button mat-menu-item (click)="copiarBusqueda()">
                <mat-icon>content_copy</mat-icon>
                <span>Copiar búsqueda</span>
            </button>

            <button mat-menu-item (click)="productosListadoPDF()">
                <mat-icon>picture_as_pdf</mat-icon>
                <span>Descargar PDF</span>
            </button>
        </mat-menu>
    </form>
  </div>
</header>
<div class="spinner-container" *ngIf="(feedProductos.cargando && feedProductos.productos.length == 0) || downloadPDF.cargando" >

    <mat-spinner *ngIf="(feedProductos.cargando && feedProductos.productos.length == 0) || downloadPDF.cargando" class="d-block mx-auto my-5 enelcentro" diameter="100"></mat-spinner>
</div>
<section *ngIf="!downloadPDF.cargando" infiniteScroll [scrollWindow]="true" [infiniteScrollThrottle]="10" [infiniteScrollDistance]="0.5" (scrolled)="onScroll()">
    <div class="grid-list mx-auto px-2" >
        <div class="d-flex m-0 my-5" *ngIf="!feedProductos.cargando && feedProductos.productos.length == 0">
            <h3 class="text-center w-100">- Búsqueda sin resultados -</h3>
        </div>
        <div class="my-5 cursor-pointer" *ngFor="let producto of globals.feedProductos.productos; let i = index;" (click)="detalleProducto( producto )" id="{{ producto.stockid }}">
            <div class="d-flex m-0">
                <div class="pe-3">
                    <div class="box-img">
                        <img class="img-producto" *ngIf="producto.imagenes.length > 0" [src]="producto.imagenes[0].med">
                        <img class="img-producto" *ngIf="producto.imagenes.length == 0" src="/assets/img/producto-sin-imagen.svg">
                    </div>
                </div>
                <div class="flex-grow-1">
                    <div class="mb-1">{{ producto.description_clear }}</div>
                    <div class="sku">SKU: {{ producto.stockid }}</div>
                </div>
                <div class="ps-3">
                    <div>${{ producto.precio_final_con_impuesto_format }}</div>
                    <div *ngIf="globals.configuracion.front.typeabbrev == '02' && producto.precio_unico == 0 && producto.precio_mayor != 0"><s>${{ producto.precio_detal_con_impuesto_format }}</s></div>
                </div>
            </div>
            <div *ngIf="producto.tags.length > 0" class="box-tags d-flex flex-wrap">
                <!--
                <mat-chip-list>
                    <mat-chip *ngFor="let tag of producto.tags | slice:0:5" color="accent" selected>{{ tag.modeldescrip }}</mat-chip>
                    <ng-container *ngIf="producto.tags.length > 5">
                        <mat-chip color="accent" [matMenuTriggerFor]="moreTags">Más...</mat-chip>
                        <mat-menu #moreTags="matMenu">
                            <button *ngFor="let tag of producto.tags | slice:5" mat-menu-item>{{ tag.modeldescrip }}</button>
                        </mat-menu>
                    </ng-container>
                </mat-chip-list>
                -->
                <div class="flex-grow-1">
                    <span class="tag-producto" *ngFor="let tag of producto.tags | slice:0:5">{{ tag.modeldescrip }}</span>
                    <ng-container *ngIf="producto.tags.length > 5">
                        <span class="tag-producto" [matMenuTriggerFor]="moreTags" (click)="masTags($event)">...</span>
                        <mat-menu #moreTags="matMenu">
                            <button *ngFor="let tag of producto.tags | slice:5" mat-menu-item>{{ tag.modeldescrip }}</button>
                        </mat-menu>
                    </ng-container>
                </div>
                <div class="ps-2 pt-2">
                    
                    <button mat-raised-button color="accent">Comprar</button>
                </div>
            </div>
            <mat-divider class="mt-2"></mat-divider>
        </div>
    </div>
</section>
<div class="spinner-container" *ngIf="feedProductos.cargando && feedProductos.productos.length > 0">
    <mat-spinner *ngIf="feedProductos.cargando && feedProductos.productos.length > 0" class="d-block mx-auto mb-5 margin-new enelcentro" diameter="100"></mat-spinner>
</div>
